import React from 'react';
import {getScanners, startAccuscanCalibration} from 'services/testConnect';
import ReactDOM from 'react-dom';
import events from 'lib/events';
import router from 'lib/router';
import routeUtils from 'util/routeUtils';
import Header from 'components/layout/header';
import Loader from 'components/loader';
import Timer from 'components/timer';
import IntlWrapper from 'components/layout/intlWrapper';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';

let render = container => {
  console.info('[UI.page.tools] rendering page');
  ReactDOM.render(<IntlWrapper><CopperCalibration /></IntlWrapper>, container);
  events.publish('page-change', {page: 'tools'});
};

console.info('[UI.page.tools] register route');
router.rr.add([{path: 'tools/calibration/accuscan', handler: routeUtils.requireAuth(render)}]);

class CopperCalibration extends React.Component {
  state = {
    currentStep: 1,
    scannerError: false,
    scannerInitialized: false,
    subStep: 1,
  };

  componentWillMount() {
    this.initializeScanner();

    events.subscribe('scanner.complete', () => {
      if (this.state.currentStep < 4) {
        this.setState({
          subStep: 1,
          currentStep: this.state.currentStep + 1,
        });
      }
    });
  }

  beginCalibration = () => {
    this.setState({subStep: this.state.subStep + 1});

    startAccuscanCalibration();
  };

  initializeScanner = () => {
    getScanners()
      .then(data => {
        if (!data || !data.scanners || !data.scanners.includes('Accuscan')) {
          this.setState({
            scannerInitialized: true,
            scannerError: true,
          });
          return;
        }

        this.setState({
          scannerInitialized: true,
          scannerError: false,
          securityError: false,
        });
      })
      .catch(err => {
        console.error(err);
        this.setState({
          scannerInitialized: true,
          scannerError: true,
          securityError: true,
        });
      });
  };

  showCurrentStep = () => {
    let stepGraphic =
      <div className='row steps-container'>
        <div className='col-md-3 steps'>
          <i className='step-icon'>{this.state.currentStep > 1 ? <i className='bl bl-check'/> : 1}</i>
          <div className='form-group'>
            <h3><FormattedMessage id="tools.cooper.test" /></h3>
            <p>1st <FormattedMessage id="general.reading" /></p>
          </div>
        </div>
        <div className='steps-arrow' />
        <div className='col-md-3 steps'>
          <i className='step-icon'>{this.state.currentStep > 2 ? <i className='bl bl-check'/> : 2}</i>
          <div className='form-group'>
            <h3><FormattedMessage id="tools.cooper.test" /></h3>
            <p>2nd <FormattedMessage id="general.reading" /></p>
          </div>
        </div>
        <div className='steps-arrow' />
        <div className='col-md-3 steps'>
          <i className='step-icon'>{this.state.currentStep > 3 ? <i className='bl bl-check'/> : 3}</i>
          <div className='form-group'>
            <h3><FormattedMessage id="tools.cooper.test" /></h3>
            <p>3rd <FormattedMessage id="general.reading" /></p>
          </div>
        </div>
        <div className='steps-arrow' />
        <div className='col-md-3 steps'>
          <i className='step-icon'>4</i>
          <div className='form-group'>
            <h3><FormattedMessage id="general.calibration" /> <br /> <FormattedMessage id="general.complete" /></h3>
          </div>
        </div>
      </div>

    ;

    if (this.state.scannerError) {
      return (
        <p><FormattedMessage id="tools.accusan.not.connected" /></p>
      );
    }

    if (this.state.currentStep === 4) {
      return (
        <div>
          {stepGraphic}
          <p><FormattedMessage id="tools.cooper.calibration.successfully" /></p>
          <a className='btn btn-primary' href='#tools/calibration'>OK</a>
        </div>
      );
    }

    return (
      <div>
        {stepGraphic}
        {this.showSubStep()}
      </div>
    );
  };

  showSubStep = () => {
    let instructions, timer;

    if (this.state.subStep === 1) {
      instructions =
        <div>
          <p><FormattedMessage id="tools.cooper.prepare.cooper" /></p>
          <p><FormattedMessage id="tools.cooper.dip.cooper" /></p>
          <p><FormattedMessage id="tools.cooper.click.start" /></p>
        </div>
      ;
    } else if (this.state.subStep === 2) {
      instructions =
        <p><FormattedMessage id="tools.cooper.water.sample" /></p>
      ;
    } else if (this.state.subStep === 3) {
      instructions =
        <div>
          <p><FormattedMessage id="tools.cooper.remove.strip" /></p>
          <p><FormattedMessage id="tools.cooper.click.wait" /></p>
        </div>
      ;
    } else if (this.state.subStep === 4) {
      instructions =
        <p><FormattedMessage id="tools.cooper.press.green" /><sup>®</sup> II <FormattedMessage id="tools.cooper.wait.complete" /></p>
      ;
    } else {
      instructions =
        <p><FormattedMessage id="tools.cooper.reseting.scanner" /></p>
      ;
    }

    if (this.state.subStep === 1 || this.state.subStep === 2) {
      timer =
        <Timer seconds={15} timerId={1}
          start={() => this.setState({subStep: this.state.subStep + 1})}
          complete={() => this.setState({subStep: this.state.subStep + 1})} />
      ;
    } else if (this.state.subStep === 3) {
      timer =
        <Timer seconds={15} timerId={3}
          start={() => {}}
          complete={this.beginCalibration} />
      ;
    }

    return (
      <div>
        {instructions}
        {timer}
      </div>
    );
  };

  render() {
    if (this.state.securityWarning) {
      return (
        <div className='container'>
          <h3><FormattedMessage id="tools.cooper.complete.test" /></h3>
          <br />
          <p><a className='btn btn-default' href='#support/ie-security-error'><FormattedMessage id="general.click.troubleshoot" /></a></p>
        </div>
      );
    }

    return (
      <div className='calibration-page container'>
        <Header mainTitle={this.props.intl.formatMessage({id: 'tools.cooper.accuscan.calibration'})} mainTitleReturn='tools' />
        <div className='calibration-header'>
          <h3><FormattedMessage id="tools.cooper.process.reading" /></h3>
          <h3><FormattedMessage id="tools.cooper.follow.instructions" /></h3>
        </div>
        <Loader loaded={this.state.scannerInitialized}>
          {this.showCurrentStep()}
        </Loader>
      </div>
    );
  }
}

export default injectIntl(CopperCalibration);
